<template>
  <div class="well style-3" style="padding: 1em; background: white; overflow: hidden auto; height: 68vh;">
    <el-row :gutter="24">
      <el-col :span="10">
        <div class="div-memo" >
          <div class="text-header title-text">推薦人資料</div>
          <el-row>
            <el-button icon="el-icon-edit" type="primary" @click="showModal()"
              v-if="form.timeFg">編輯推薦人資料</el-button>
          </el-row>
          <section class="modal-body" id="modalDescription">
              <el-form ref="form" :model="form" label-width="130px" label-position="left" size="medium">
                <!--<el-form-item style="margin-bottom: 1em;">
                  </el-form-item> -->
                  <el-form-item label="姓名" prop="name" style="border-bottom: 1px solid #a7a8bd;">
                      {{form.name}}
                  </el-form-item> 
                  <el-form-item label="任職單位" prop="unit" style="border-bottom: 1px solid #a7a8bd;">
                      {{form.unit}}
                  </el-form-item> 
                  <el-form-item label="職稱" prop="title" style="border-bottom: 1px solid #a7a8bd;">
                      {{form.title}}
                  </el-form-item> 
                  <el-form-item label="與申請人關係" prop="relation" style="border-bottom: 1px solid #a7a8bd;">
                      {{form.relation}}
                  </el-form-item> 
                  <el-form-item label="Email" prop="email" style="border-bottom: 1px solid #a7a8bd;">
                      {{form.email}}
                  </el-form-item> 
                  <el-form-item label="連絡電話" prop="phoneNo" style="border-bottom: 1px solid #a7a8bd;" v-show="false">
                      {{form.phoneNo}}
                  </el-form-item> 
              </el-form>
          </section>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="div-memo" >
            <div class="text-header title-text">上傳作業</div>
            <div v-html="memo">
            </div><br/>
            <ul style="list-style-type:trad-chinese-informal; line-height: 2.25rem;">
              <li>請以 PDF 格式之檔案上傳，檔案大小以 10MB 為限</li>
              <li>參考格式：<a :href="'./WebApi/Tools/ShowSystemDoc/'.concat(sysId).concat('/8')" target="_blank"
                        :title="setting.templateFile[0].codeName">下載檔案</a></li>
              <li>請使用 Google Chrome、Internet Explorer 11 以上或 Firefox 等瀏覽器瀏覽，請勿使用智慧型手機或平板電腦操作</li>
            </ul>
            <br/>
            <el-row>
            目前狀態：<b style="color: #1a6840;">{{currentStatus}}</b>
            </el-row> <br/>
              <!--     <el-button-group> -->
          <el-row v-if="form.timeFg">
              <el-button type="warning" @click="reject()" icon="el-icon-close" plain style="font-weight: bold;"
                v-if="form.status<2">拒絕推薦</el-button>
              <el-button type="primary" @click="upload()" icon="el-icon-upload2" plain style="font-weight: bold;"
                v-if="form.status<2">上傳推薦函</el-button>
          </el-row>
          <span style="color: rgb(130, 17, 31); text-align: center; font-weight: bold; font-size: larger;"
            v-else>~已超過上傳推薦信作業時間~</span> 
        <!--     </el-button-group> -->
        </div>
      </el-col>
    </el-row>
    <modal name="hello-world"
      @closed="modalClose">
        hello, world!
    </modal>
  </div> 
</template>

<script id="modal-template">
import editData from '@/components/EditData.vue'
export default {
  name: 'recommend',
  components: {
    editData
  },
  data () {
    return {
      isModalVisible: false,
      form: {
        documentID: 0,
        recID: 0,
        name: '',
        unit: '',
        title: '',
        relation: '',
        email: '',
        phoneNo: '',
        status: 255,
        timeFg: false
      },
      memo: ''
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    currentStatus() {
      var ret = '';
      switch (this.form.status) {
        case 3:
          ret = '已完成推薦，謝謝您！';
          break;
        case 2:
          ret = '已拒絶推薦...';
          break;
        default:
          ret = '您已同意推薦，請繼續上傳推薦檔案...';
          break;
      }
      return ret;
    }
  },
  methods: {
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    },
    showModal() {
      this.$modal.show(editData, {
        recId: this.user.deptID,
        mode: 3
      }, {
        height: 'auto'
      }, {
        'closed': this.modalClose
      })
    },
    modalClose (event) {
    console.log('======modalClose====='+event);
        this.query();
    },
    getUploadMemo: function (id) {
      return this.$http
                 .get('./WebApi/Apply/GetUploadMemo/'.concat(this.sysId).concat("/").concat(this.user.deptID));
    },
    getRecommendList: function () {
      return this.$http
                 .get('./WebApi/Apply/GetRecommendList/'.concat(this.user.dId));
    },
    query() {
      let vm = this
      this.$http
          .get('./WebApi/Apply/GetRecommendInfo/'.concat(this.user.deptID))
                .then(function(response) {
              if (response != null) {
                  vm.form.recID      = response.data.recID;
                  vm.form.documentID = response.data.documentID;
                  vm.form.name       = response.data.name;
                  vm.form.title      = response.data.title;
                  vm.form.unit       = response.data.unit;
                  vm.form.relation   = response.data.relation;
                  vm.form.email      = response.data.eMail;
                  vm.form.phoneNo    = response.data.phoneNo;
                  vm.form.status     = response.data.status;
                  vm.form.timeFg     = response.data.timeFg;
              }
          })
          .catch(function (error) {
            vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
          })
    },
    reject() {
      var vm = this
      this.$http.get('./WebApi/Apply/RejectRecommend/'.concat(this.form.recID))
        .then((response) => {
          if (response.data === true) {
            vm.$message({
              message: '恭喜您,儲存成功',
              type: 'success'
            })
            vm.query ()
          }
          else {
            vm.$message.error('對不起,儲存失敗')
          }
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗' + error)
        })
    },
    upload() {
        this.$emit('toggle', 'Upload')
    }
  },
  created () { 
    console.log('======created ModifyView=====');
    var vm = this;
    this.$http.all([vm.getUploadMemo()])
              .then(vm.$http.spread(function (memoInfo) {
                vm.memo = memoInfo.data; 
                vm.query();
              }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .td-style {
    width: 20%;
    text-align: right;
  }
  .div-memo {
    padding: 0.5em 0 0;
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
  .text-header {
    font-weight: bolder;
    text-align: center;
    top: 30px;
    width: 110px;
    position: absolute;
    background: white;
  }
  .title-text {
    top: -0.8em;
    font-size: medium;
    font-weight: bolder;
    color: #1c2938;
  }
  .style-3::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px #e9ddb6;
    background-color: #F5F5F5;
	  border-radius: 2px;
  }
  .style-3::-webkit-scrollbar
  {
    width: 2px;
    background-color: #F5F5F5;
  }
  .style-3::-webkit-scrollbar-thumb
  {
    background-color:#47484c;
	  border-radius: 2px;
  }
  /* ul {
    list-style: square inside url("/assets/images/image.gif");
  } */
</style>


// WEBPACK FOOTER //
// src/components/ModifyView.vue